import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { RootReducer } from 'src/redux/rootReducer'
import {
  FETCH_MARKETPLACE_OFFERS,
  FETCH_MARKETPLACE_OFFERS_FAILURE,
  FETCH_MARKETPLACE_OFFERS_SUCCESS,
  MarketplaceOffer
} from 'src/redux/marketplaceOffersReducer'

interface Response {
  total_pages: number
  total_count: number
  offers: MarketplaceOffer[]
  page: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchMarketplaceOffersFlow(): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/api/v2/offers/marketplace_candidates'
    const currentPage = yield select((state: RootReducer) => state.marketplaceOffersReducer.currentPage)
    const searchTerm = yield select((state: RootReducer) => state.marketplaceOffersReducer.searchTerm)
    const response: Response = yield call(apiCall, {
      endpoint,
      method: GET,
      params: {
        page: currentPage,
        query: searchTerm
      }
    })
    yield put(
      FETCH_MARKETPLACE_OFFERS_SUCCESS({
        marketplaceOffers: response.offers,
        totalPages: response.total_pages,
        totalCount: response.total_count
      })
    )
  } catch (error) {
    yield put(FETCH_MARKETPLACE_OFFERS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchMarketplaceOffersSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_MARKETPLACE_OFFERS, FetchMarketplaceOffersFlow)
}
